/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import dayjs from 'dayjs';
import { IGlucoUser } from 'app/shared/model/gluco-user.model';

export interface IPressure {
  id?: string;
  cursor?: number;
  active?: boolean;
  created?: dayjs.Dayjs | null;
  maxReading?: number;
  microSec?: number;
  minReading?: number;
  timestampentry?: number;
  pulse?: number | null;
  oximetry?: number | null;
  lastupdated?: number;
  glucoUser?: IGlucoUser;
}

export const defaultValue: Readonly<IPressure> = {
  active: false,
};
